import { NotebookHeartOutlineIcon } from './NotebookHeartOutlineIcon';

/**
 * author: Austin Andrews
 * id 0F8BCA10-0144-4507-850B-777AE12B3A80
 * name notebook-heart-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/notebook-heart-outline.svg
 * tags
 */
export const NotebookFavoriteOutlineIcon = NotebookHeartOutlineIcon;
export default NotebookFavoriteOutlineIcon